module.exports = __webpack_public_path__ + "static/media/garage.6c7124a3.svg";